import { useMemo, useState } from "react";
import { AppLayout } from "../../components/layout/Header";
import { useAuth } from "../../js/hooks/useAuth";
import {
  acknowledgeNotice,
  kindLabel,
  listNoticeAcks,
  listSystemNotices,
} from "../../js/api/systemNotices";
import { formatDate } from "../../js/utils/formatters";
import { toTitleCase } from "../../js/utils/titleCase";

export default function SystemNoticesPage() {
  const { session } = useAuth();
  const [pulse, setPulse] = useState(0);
  const notices = useMemo(() => listSystemNotices(), [pulse]);
  const acks = useMemo(() => listNoticeAcks(session?.userId), [session, pulse]);

  function ack(id) {
    if (!session?.userId) return;
    acknowledgeNotice(session.userId, id);
    setPulse((n) => n + 1);
  }

  return (
    <AppLayout>
      <article className="notices-page">
        <h1>Notices</h1>
        <div className="title-rule" />
        <p className="page-lead">
          These are <strong>system notifications</strong> for you — security updates, the annual
          upgrade, and major feature releases. They are not your Messages with your agent.
        </p>
        {!session ? (
          <p className="muted">Sign in to acknowledge notices for your account.</p>
        ) : null}
        {notices.map((notice) => {
          const done = Boolean(acks[notice.id]);
          return (
            <section key={notice.id} className={`card notice-card${done ? "" : " is-open"}`} style={{ marginBottom: "1rem" }}>
              <p className="muted">{kindLabel(notice.kind)} · {formatDate(notice.released_at)}</p>
              <h2>{toTitleCase(notice.title)}</h2>
              <p>{notice.summary}</p>
              <p className="muted">{notice.body}</p>
              <div className="ack-row">
                {done ? (
                  <span className="badge">Acknowledged {formatDate(acks[notice.id].acknowledged_at)}</span>
                ) : session ? (
                  <button type="button" className="primary-btn" onClick={() => ack(notice.id)}>
                    I have read this notice
                  </button>
                ) : (
                  <span className="muted">Sign in to acknowledge.</span>
                )}
              </div>
            </section>
          );
        })}
      </article>
    </AppLayout>
  );
}
